import React from 'react'
import Helmet from 'react-helmet'
import styled, {ThemeProvider} from 'styled-components'
import config from '../utils/siteConfig'
import globals from '../styles/global'
import theme from '../styles/theme'

import favicon from '../images/favicon.ico'

const Page = ({ children }) => {

    return (
      <div>

        <Helmet>
          <title>{config.siteTitle}</title>
          {/*<meta charSet="utf-8" />*/}
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
          <link rel="icon" href={favicon} />
          <link href="https://fonts.googleapis.com/css?family=Quicksand:500|Roboto:400,700" rel="stylesheet" />
          <meta name="description" content={config.siteDescription}/>
          <meta property="og:title" content={config.siteTitle} />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={config.siteTitle} />
          <meta property="og:url" content={config.siteUrl}/>

          <html lang="en" />

          {/* Global site tag (gtag.js) - Google Analytics */}
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-170141347-1"></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
            
              gtag('config', 'UA-170141347-1',{ 'anonymize_ip': true });
            `}
          </script>
        </Helmet>

        <ThemeProvider theme={theme}>
          <div>
            {children()}
          </div>
        </ThemeProvider>

      </div>
    )
}

export default Page



// WEBPACK FOOTER //
// ./src/layouts/index.js